<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row>
        <v-col>
          <h3><v-icon class="mr-2">mdi-message-lock-outline</v-icon> Histórico de SLAS</h3>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>
      <v-data-table dense :headers="headers" :items="data">
        <template v-slot:[`item.date`]="{ item }">
          {{ item.date | formatFullDate }}
        </template>

        <template v-slot:[`item.message`]="{ item }">
          <v-btn icon tile @click="view(item.text)">
            <v-icon>mdi-magnify-scan</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.ruleaction`]="{ item }">
          <v-btn icon tile @click="viewRule(item)">
            <v-icon>mdi-ruler-square</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <TheDialog title="Mensagem" v-model="dialog" icon="mdi-message-lock-outline" width="480px">
      <template>
        <div v-html="text"></div>
      </template>
      <template v-slot:actions>
        <TheButton text="Fechar" icon="mdi-close" @click="dialog = false" color="red" />
      </template>
    </TheDialog>

    <TheDialog title="Mensagens" v-model="dialogRule" icon="mdi-message-bulleted" width="80%">
      <template>
        <v-row>
          <v-col><TheInput label="Título" v-model="sla.rule" disabled/></v-col>
        </v-row>
        <v-row>
          <v-col><vue-editor v-model="sla.text" disabled/></v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col>
            <v-select
              outlined
              dense
              hide-details
              :items="actions"
              item-value="value"
              item-text="text"
              label="Ação"
              v-model="sla.action"
              disabled
            ></v-select>
          </v-col>
          <v-col cols="1">
            <TheInput label="Status 1" v-model="sla.status1" disabled />
          </v-col>
          <v-col cols="1">
            <TheInput label="Status 2" v-model="sla.status2" disabled />
          </v-col>
          <v-col>
            <v-select
              outlined
              dense
              hide-details
              :items="time"
              item-text="text"
              item-value="value"
              label="Quando"
              v-model="sla.time"
              disabled
            ></v-select>
          </v-col>
          <v-col>
            <v-checkbox label="Repetir?" v-model="sla.repeat" disabled></v-checkbox>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions>
        <TheButton text="Fechar" icon="mdi-close" @click="dialogRule = false" color="red" />
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { VueEditor } from 'vue2-editor'
import TheInput from '@/components/TheInput'
import TheButton from '@/components/TheButton'
import TheDialog from '@/components/TheDialog'

export default {
  name: 'SlaMessages',
  components: {
    TheInput,
    TheDialog,
    TheButton,
    VueEditor,
  },
  data: () => ({
    headers: [
      { text: 'Seller', value: 'sellerId' },
      { text: 'Usuário', value: 'userId' },
      { text: 'Mensagem', value: 'rule' },
      { text: 'Data Envio', value: 'date' },
      { text: 'Mensagem', value: 'message', width: '15%', align: 'center' },
      { text: 'Regra', value: 'ruleaction', width: '15%', align: 'center' },
    ],
    data: [],
    dialog: false,
    dialogRule: false,
    actions: [
      { text: 'Mudança de Status de Pedido', value: 1 },
      { text: 'Tempo em Status', value: 2 },
    ],
    time: [
      { text: 'Instântaneo', value: '0' },
      { text: '2h', value: '1' },
      { text: '4h', value: '2' },
      { text: '6h', value: '3' },
      { text: '8h', value: '4' },
      { text: '1d', value: '5' },
      { text: '2d', value: '6' },
      { text: '3d', value: '7' },
      { text: '4d', value: '8' },
    ],
    text: '',
    sla: {},
  }),
  methods: {
    loadData() {
      axios
        .get(`${baseApiUrl}/sla/history`)
        .then((res) => {
          this.data = res.data
        })
        .catch(showError)
    },
    view(text) {
      this.text = text
      this.dialog = true
    },
    viewRule(item) {
      this.sla = item
      this.dialogRule = true
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style></style>
